import React, { useContext, useEffect, useState } from "react";
import { Box, useMediaQuery, Typography } from "@mui/material";
import { AuthContext } from "../contexts/AuthContext";
import CurrentDate from "../components/CurrentDate";
import Greeting from "../components/Greeting";
// import CalendarBar from "../components/CalendarBar";
// import EventCardSlider from "../components/EventCardSlider";
// import Exhibition from "../components/Exhibition";
// import { prodApi } from "../data/api";
// import { fetchSecureData } from "../functions";

// const exhibitionsUrl = `${prodApi.data}/exhibitions`;

const Home = ({ maxWidth }) => {
  const { loggedIn, isLoggedIn } = useContext(AuthContext);
  // const [exhibitionsData, setExhibitionsData] = useState([]);
  // const [exhibitionsDataLoaded, setExhibitionsDataLoaded] = useState(false);
  // eslint-disable-next-line
  // const [error, setError] = useState("");
  // const isTab = useMediaQuery("(max-width:700px)");
  // const [selectedDate, setSelectedDate] = useState(today);

  // useEffect(() => {
  //   if (isLoggedIn?.accessLevel !== "pending") {
  //     fetchSecureData(
  //       exhibitionsUrl,
  //       setExhibitionsData,
  //       exhibitionsDataLoaded,
  //       setExhibitionsDataLoaded,
  //       setError
  //     );
  //   }
  // }, [exhibitionsDataLoaded]);

  if (loggedIn && isLoggedIn?.accessLevel === "pending") {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontWeight: "bold", color: "grey.700", p: 2 }}
        >
          Application under review, you will be notified upon change.
        </Typography>
      </Box>
    );
  }

  if (loggedIn && isLoggedIn?.accessLevel === "suspended") {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontWeight: "bold", color: "grey.700", p: 2 }}
        >
          Your account has been suspended, contact admin.
        </Typography>
      </Box>
    );
  }

  // console.log(exhibitionsData);
  return (
    <>
      {loggedIn && (
        <Box sx={{ position: "relative" }}>
          <Box
            sx={{
              minHeight: "110dvh",
              width: "90%",
              maxWidth: maxWidth,
              m: "auto",
              p: "auto",
            }}
          >
            <Box
              sx={{
                mt: 9,
                mb: 1.5,
                fontSize: "2rem",
                fontWeight: "300",
              }}
            >
              Home
            </Box>
            <CurrentDate />
            <Greeting user={isLoggedIn.firstName} />
            {/* <Exhibition data={exhibitionsData} /> */}
            {/* <EventCardSlider aspectRatio={isTab ? "1/1" : "2/1"} /> */}
            <Box sx={{ height: "10dvh" }} />
          </Box>
        </Box>
      )}
    </>
  );
};

export default Home;
